import React, { useCallback } from "react";

import { Skeleton } from "components";

import styles from "../../merchantInfo.module.scss";

type FieldRowProps = {
	label: string;
	data: string;
	isLoading: boolean;
	className?: string;
};

export const FieldRow = ({
	isLoading,
	data,
	label,
	className = "",
}: FieldRowProps) => {
	const FieldWithLoader = useCallback(
		({ text }) => {
			if (isLoading) {
				return (
					<Skeleton
						variant="text"
						marginRight={"40px"}
						marginBottom="16px"
						height="24px"
						width="90%"
					/>
				);
			} else {
				return <div className={styles.content}>{text}</div>;
			}
		},
		[isLoading],
	);
	return (
		<div className={styles.merchantFormDesc}>
			<label className={styles.merchantLabel}>{label}</label>
			<div className={`${styles.formContent} ${className}`}>
				<FieldWithLoader text={data} />
			</div>
		</div>
	);
};
